import { type AccountManagerModel } from "@doitintl/cmp-models";
import { type ModelReference } from "@doitintl/models-any";

export const upload = async (files: File[]) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("attachments", file);
  });

  try {
    const response = await fetch("/api/ava/upload", {
      method: "POST",
      body: formData,
    });

    const result = (await response.json()) as string[];
    return result;
  } catch (error) {
    return [];
  }
};

export const getAccountManagerEmail = async (ref: ModelReference<AccountManagerModel>) => {
  const doc = await ref.get();
  if (doc.data()) {
    return doc.data()?.email;
  }
};

export function extractAttachments(message: string): { cleanedMessage: string; attachments: string[] } {
  const attachmentRegex = /(https:\/\/firebasestorage\.googleapis\.com\/[^\s]+)/g;
  const attachments: string[] = [];
  let cleanedMessage = message;
  if (message.includes("$attachments:")) {
    // Check if the message contains attachments section
    const parts = message.split("$attachments:");
    cleanedMessage = parts[0].trim();

    // If there's an attachments section, process it
    if (parts.length > 1) {
      const attachmentText = parts[1].trim();
      const urls = attachmentText.match(attachmentRegex) || [];

      // Extract filenames from URLs based on new rule
      urls.forEach((url) => {
        // Extract the path part from the URL
        const nameMatch = url.match(/\/o\/([^?]+)/);
        if (nameMatch) {
          const fullPath = decodeURIComponent(nameMatch[1]);
          // Extract filename up to the timestamp part (which follows the pattern of _TIMESTAMP_)
          const fileNameMatch = fullPath.match(/(.+)_\d{13}_\d+\.\w+$/);
          const fileName = fileNameMatch ? fileNameMatch[1] : "unknown";
          attachments.push(fileName);
        }
      });
    }
  } else if (message.includes("$file-names:")) {
    const fileParts = message.split("$file-names:");
    if (fileParts.length > 1) {
      const fileNames = fileParts[1].trim();
      const fileNamesArray = fileNames.split(", ");
      attachments.push(...fileNamesArray);
      cleanedMessage = fileParts[0].trim();
    }
  } else {
    cleanedMessage = message;
  }

  return { cleanedMessage, attachments };
}
